var fileInput = new FileInput(".js-upload", {
    minKo: 5,
    maxKo: 5000,
    defaultImagePreview: '<label for="Drawing"></label>'

});

$('#submit-form-with-optin').on('click', function () {
    $('#IsNewsletterOptin').val("True");
});

var isMobile = function () {
    if ($(".hide-for-small").css('display') === 'none') {
        return true;
    }
    return false;
}

$(document).ready(function () {
    if ($("#wrapper-game").attr("data-scroll-to-form") != undefined && $("#wrapper-game").attr("data-scroll-to-form") == "True") {
        document.getElementById("form").scrollIntoView({ behavior: 'smooth' }, true);
    }
});
$("#participate").click(function (e) {
    e.preventDefault();
    var id = $(e.currentTarget).attr("href");
    var top = 0;
    if (isMobile()) {
        top = $(id).offset().top - $("#main-header").outerHeight();
    } else {
        top = $(id).offset().top;
    }
    $("html, body").animate({
        scrollTop: top
    }, 200);
});